module.exports = __webpack_public_path__ + "img/tg-round-gray-icon.28ac7b6c.svg";